<template>
<div>

<div class="modal-content border border-success">
<div  style="background-color:#9acd32;color:black" class="modal-header border border-success text-nowrap ">
  <h4 class="modal-title ">
    <i style="color:blue" class="fas fa-cash-register mr-3" aria-hidden="true"></i>     
    <strong>STAMPA SCONTRINO FISCALE</strong>
    <hr>
    <span><strong>{{ data.url }}</strong></span>
  </h4>  
</div>

<div class="modal-body border border-success">
  <span style="color:red" v-if="msg.title"> {{ msg.body }}</span>
<div>
  <div class="form-check form-check-inline">
  <input checked class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" :value="1" v-model="paid">
  <label class="form-check-label" for="inlineRadio1"><strong>CON LISTA PRODOTTI</strong></label>
</div>
<div class="form-check form-check-inline ml-4">
  <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" :value="2" v-model="paid">
  <label class="form-check-label" for="inlineRadio2"><strong>CON ACCONTO</strong></label>
</div>
</div>


<!--
<div class="form-check form-check-inline">
  <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio3" value="option3" disabled>
  <label class="form-check-label" for="inlineRadio3">3 (disabled)</label>
</div>
-->

  <!--<alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>-->
</div>

<div class="modal-footer">
    <button @click="$emit('close')" type="button" class="btn btn-secondary ">
      <i class="fas fa-reply mr-2" aria-hidden="true"></i>
        ANNULLA
    </button>

    <button  @click="getData()" :disabled="bt_spinner==true" type="button" class="btn btn-primary ">
          <i class="fas fa-print mr-2" aria-hidden="true"></i>   
            STAMPA SCONTRINO 
          <span v-if="bt_spinner"  class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
    </button> 

    <!--
       <button  @click="test()" :disabled="bt_spinner==true" type="button" class="btn btn-primary ">
          <i class="fas fa-print mr-2" aria-hidden="true"></i>   
            TEST
          <span v-if="bt_spinner"  class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
    </button> 
  -->
    

    

</div>

</div>
</div>


</template>

<script>

import { mapGetters } from 'vuex';

import api               from '@/api'
import axios             from 'axios'
import alertBox          from '@/components/common/AlertBox.vue'

//import fmt               from '@/components/mixins/fmt'
import getSaleData        from '@/components/rt/mixins/getSaleData'
import updateFPStatus     from '@/components/rt/mixins/UpdateFiscalPrintStatus'
import { setFmtDate4}     from '@/functions' 


  export default {
  mixins : [getSaleData,updateFPStatus],
  props  : ['data'],

     components: {alertBox},
    data () {
      return {
        
          msg      : {title : '',body:'',type :0},
        
        
          items       : [],
          payments    : [],
          bt_spinner  : false,
          paid        : 1
                                   
      }
    },
      computed :{
      ...mapGetters(['company']),
   
    },
      
    created () 
      {
        //console.log('EPSON FISCAL RECEIPT DATA',this.data)
                
      },
    
    methods: 
    {
     
    /*      
     test()
     {


      let xml = '<?xml version="1.0" encoding="utf-8"?><soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/"><soapenv:Body><response success="true" code="" status="2">'
	    xml += '<addInfo><elementList>lastCommand,printerStatus,fiscalReceiptNumber,fiscalReceiptAmount,fiscalReceiptDate,fiscalReceiptTime,zRepNumber</elementList>'
        xml += '<lastCommand>74</lastCommand>'
		xml += '<printerStatus>00110</printerStatus>'
		xml += '<fiscalReceiptNumber>10</fiscalReceiptNumber>'
		xml += '<fiscalReceiptAmount>65,90</fiscalReceiptAmount>'
		xml += '<fiscalReceiptDate>3/10/2024</fiscalReceiptDate>'
		xml += '<fiscalReceiptTime>13:4</fiscalReceiptTime>'
		xml += '<zRepNumber>2005</zRepNumber>'
    xml += '<serialNumber>XXXXXXXXXXX</serialNumber>'
	  xml += '</addInfo>'
    xml += '</response>'
    xml += '</soapenv:Body></soapenv:Envelope>'

        
    //console.log(this.parseFiscalReceiptResponse(xml))
    const parser              = new DOMParser()
    const xmlDoc              = parser.parseFromString(xml,"text/xml")
          
    
    const success = xmlDoc.getElementsByTagName('response')[0].getAttribute('success')
              console.log(success)
       if(success=='true')       
       {
        alert('Success');
       }

                

     },
         
      */


     parseFiscalReceiptResponse(xmlResponse)
     {

      const parser              = new DOMParser()
      const xmlDoc              = parser.parseFromString(xmlResponse,"text/xml")
      
      const response            = xmlDoc.getElementsByTagName('response')[0].getAttribute('success')
        
      //const response            = xmlDoc.getElementsByTagName("soapenv:Body")[0].childNodes[0].nextSibling.attributes[0].value
          
      let fiscalReceiptNumber   = ''
      let zRepNumber            = ''
      let serialNumber          = ''
      let fiscalReceiptDate     = ''

      if(response == 'true')
      {
        fiscalReceiptNumber       = xmlDoc.getElementsByTagName("fiscalReceiptNumber")[0].childNodes[0].nodeValue
        fiscalReceiptNumber       = fiscalReceiptNumber.padStart(4,'0')
        zRepNumber                = xmlDoc.getElementsByTagName("zRepNumber")[0].childNodes[0].nodeValue
        zRepNumber                = zRepNumber.padStart(4,'0')
        serialNumber              = xmlDoc.getElementsByTagName("serialNumber")[0].childNodes[0].nodeValue              
        fiscalReceiptDate         = setFmtDate4(xmlDoc.getElementsByTagName("fiscalReceiptDate")[0].childNodes[0].nodeValue)
      }
      
      return { 'fiscalReceiptNumber' : fiscalReceiptNumber,
               'zRepNumber'          : zRepNumber,
               'fiscalReceiptDate'   : fiscalReceiptDate,
               'serialNumber'        : serialNumber}
     },
     async saveFiscalReceiptResponse(saleId,data)
     {

      const sp         = {'sp'   : 'spCreateSaleFiscalReceipt'}          
      const json       = Object.assign(data, sp,{'saleId':saleId})
          
      await api.post(json).then(res => {
        if(res.status==200)
            {
              console.log(res.data)
            }
          else if(res.status==500)
           { 
            console.log(res.data)
           }  
           else
            {
              
                
                /*
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = res
                this.msg.type  = 1
                */
                
                 
            } 
          }).catch(err => {
              
              

          }).finally(() => {
          
        });

      
          
     },   
     getXML() 
     {
        
        let xml = ''  
          
        let SubtotalAdjustment = this.items[0].total_discount
        let single_use_voucher = 0
        this.payments.forEach(item=>{
              if(item.typeId == 'COUP')
              {
                single_use_voucher = item.amount
                //SubtotalAdjustment += item.amount
              }

              if(item.typeId == 'CB')
              {
                SubtotalAdjustment += item.amount
              }
        })  
                    
        xml = '<printerFiscalReceipt> <beginFiscalReceipt  operator="1" />'
        xml += '<Printer Num="1" />'
        const total  = this.getElecTotal()
        // TOTAL PAID
        if(this.paid == 1)
        {
        this.items.forEach(item => {                        
              xml += '<printRecItem operator="1" description="' + item.barcode + " "  + item.category + '" quantity="1" unitPrice="' + item.price + '" justification = "1" />'            
              if(Number(item.discount > 0))
              {
                xml += '<printRecItemAdjustment operator="1" adjustmentType="0" description="SCONTO ' + item.discount + '%"' + ' amount="' + item.discount_value + '" justification = "1" />'  

              }
        })
        
        if(single_use_voucher > 0)
        {
          xml += '<printRecItemAdjustment operator="1" adjustmentType="12" description="COUPON MONO USO" amount="' + single_use_voucher + '" justification = "1" comment="GIFT CARD" />'  
        }


        if(SubtotalAdjustment != '0.00')
        {
            xml += '<printRecSubtotalAdjustment operator="1" description="SCONTO" Type="1" amount="' + SubtotalAdjustment + '" justification = "2" />'
        }

        }
        else
        {

          xml += '<printRecItem operator="1" description="ACCONTO "  quantity="1" unitPrice="' + this.getDepositTotalPaid() + '" justification = "1" />'                      
        }

        
        xml += '<printRecSubtotal operator="1" Type="1"/>'
        xml += '<printBarCode operator="1" position="901" width="3" height="120" HRIPosition="1" HRIFont="A" codeType="69" code="' + "S" +  this.data.saleId + '"/>'         

        /*
        xml += '<printRecMessage operator="1" messageType="3" index="1" font="1" message="I CAMBI SI EFFETTUANO DA LUNEDI" />'
        xml += '<printRecMessage operator="1" messageType="3" index="2" font="1" message="A VENERDI ESIBENDO LO SCONTRINO" />'
        xml += '<printRecMessage operator="1" messageType="3" index="3" font="1" message=" ENTRO 7 GIORNI DALL\'ACQUISTO." />'
        */

        /*
        if(this.data.lottery)
        {
            xml += '<printRecLotteryID operator="1" lotteryID="' + this.data.lottery + '"/>'
        }  
        */

        //const totalElec =   this.payments.filter(item => item.typeId == 'ELEC' || item.typeId == 'PAGO' || item.typeId == 'SCAL') 
       
        this.payments.forEach(item => {
            if(item.typeId == 'CASH')
            {          
              xml += '<printRecTotal operator="1" description="Pagamento contante" amount="' + item.amount + '" Type="0" index="3" justification = "2" />'
            }
            if(this.paid == 1)
            {
              if(item.typeId == 'CRED')
              {      
                xml += '<printRecTotal operator="1" description="Pagamento non riscosso" amount="' + item.amount + '" Type="5" index="0" justification = "2" />'
              }
            }

          })  

           
            
            if(total > 0)
            {
                xml += '<printRecTotal operator="1" description="Pagamento elettronico" amount="' + total + '" Type="2" index="1" justification = "2" />'                
            }

          xml += '<endFiscalReceipt  operator="1" /></printerFiscalReceipt>'
          
          console.log('EPSON FISCAL',xml)  
          return xml              
      },
      getElecTotal()
      {
        const totalElec =  this.payments.filter(item => item.typeId == 'ELEC' || item.typeId == 'PAGO' || item.typeId == 'SCAL' || item.typeId == 'BONI' || item.typeId == 'EDEN' || item.typeId == 'KLAR') 
         // ELEC PAYMENT
         let total = 0
            totalElec.forEach(item => {                
                total += item.amount
            })
          return total

      },
      getDepositTotalPaid()
      {
        let total = 0
        this.payments.forEach(item => {
            if(item.typeId == 'CASH')
            {          
              total += item.amount
            }
            if(item.typeId == 'ELEC')
            {          
              total += item.amount
            }
            if(item.typeId == 'EDEN')
            {          
              total += item.amount
            }

          })  
          return total

      },
      getSOAP(xml)
      {
            const soap = '<?xml version="1.0" encoding="utf-8"?>\n' +
            '<s:Envelope xmlns:s="http://schemas.xmlsoap.org/soap/envelope/">\n' +
              '<s:Body>\n' + xml +
            '</s:Body>\n' +
            '</s:Envelope>\n'
            return soap
      },
      getData()
      { 
        
        
        this.bt_spinner = true
        const data     = this.getSaleData(this.data.saleId)
        data.then((res) => { 
            console.log('SALE DATA ',res);
            this.items     = res[0]
            this.payments  = res[1]
            this.postXML()
          }).catch((err) => { 
            this.items     = []
            this.payments  = []
            console.log(err);
            });
      },
      postXML()      
      {   
        
          this.msg.title = ''
          this.bt_spinner = true
          const soap = this.getSOAP(this.getXML())
          
          
          axios({
               
               url    : this.data.url + '/cgi-bin/fpmate.cgi',
               method : 'post',
               data   : soap

             }).then(res => {

                this.bt_spinner = false
                console.log('EPSON RESPONSE ',res)
                this.updateFiscalPrintStatus(this.data.saleId)

               //const success = res.getElementsByTagName('response')[0].getAttribute('success')
               //console.log()
              /*
              if (!/^(1|true)$/.test(success)) {
                  alert('Success');
                 }
                */


                const response = this.parseFiscalReceiptResponse(res.data)
                if(response.fiscalReceiptNumber )
                {
                  this.saveFiscalReceiptResponse(this.data.saleId,response)
                  //this.updateFiscalPrintStatus(this.data.saleId)
                  this.$emit('close')
                }
                else
                {
                  this.msg.title = 'ATTENZIONE '
                  //this.msg.body  = res.data
                  this.msg.body  = 'DATI DELLO SCONTRINO NON RESTITUITI CORRETTAMENTE.'
                  this.msg.type  = 1                  
                }

                
             }).catch(err => {
                
                this.bt_spinner   = false   
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = err
                this.msg.type  = 1                          

               console.log('Errore Fiscal Printer ',err)  
             })
       
      }, 

      
   
     } 
      

    
  }
</script>
<style scoped>


.modal-footer {  
  justify-content: space-between;  
}


 
  h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
}
.modal-content
{
  width:  500px;
}
.form-check-label
{
  cursor: pointer;
}

</style>
